import { render } from "./Index.vue?vue&type=template&id=5d5d8050&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=5d5d8050&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5d8050"],['__file',"components/Pages/Booking/UpcomingConfirmation/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d5d8050"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d5d8050', __exports__)) {
    api.reload('5d5d8050', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=5d5d8050&scoped=true", () => {
    api.rerender('5d5d8050', render)
  })

}


export default __exports__